const responsive = {
  xs: "100px",
  sm: "500px",
  md: "800px",
  lg: "1000px",
};
export default responsive;
